// /403 — «Нет доступа» с причиной, ФИО администраторов, кодом и номером операции отказа
// (FR-016, FR-028). Номер — в адресе: он не даёт доступа к записям (FR-027а). Страница каркаса:
// заголовок page-title и строка note с причиной, ниже код и «На главную» (README «Каркас экрана»).
import { OperationIdSchema } from '@kp/contracts';
import { buttonClass } from '@kp/ui';
import { ShieldX } from '@kp/ui/icons';
import { Link, createFileRoute } from '@tanstack/react-router';
import { PageProblem } from '../../app/ErrorScreens.tsx';
import { forbiddenView, isForbiddenCode } from '../../shell/permissions.ts';
import type { ForbiddenCode } from '../../shell/permissions.ts';
import { useMe } from '../../shell/session.ts';

export const Route = createFileRoute('/_app/403')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { code?: ForbiddenCode; from?: string; operation?: string } => {
    // Чужие значения — явно undefined: иначе в useSearch остаётся исходное значение из адреса.
    const operation = OperationIdSchema.safeParse(search.operation);
    return {
      code: isForbiddenCode(search.code) ? search.code : undefined,
      ...(typeof search.from === 'string' ? { from: search.from } : {}),
      operation: operation.success ? operation.data : undefined,
    };
  },
  staticData: { crumb: 'Нет доступа' },
  component: ForbiddenPage,
});

function ForbiddenPage() {
  const { code = 'ACC-001', operation } = Route.useSearch();
  const me = useMe();
  const view = forbiddenView(
    code,
    me.admins.map((admin) => admin.fullName),
  );
  return (
    <PageProblem
      title={view.title}
      note={view.text}
      icon={ShieldX}
      code={view.code}
      operation={operation}
      action={
        <Link to="/" className={buttonClass({ variant: 'secondary' })}>
          На главную
        </Link>
      }
    />
  );
}
